var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "500px",
        title: "同步商品",
        visible: _setup.props.isShowing,
        "before-close": _setup.cancel,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_setup.props, "isShowing", $event)
        },
      },
    },
    [
      _c("div", [_vm._v("确定将商品为选品中心推荐商品，同时")]),
      _c(
        "el-radio-group",
        {
          staticStyle: { "margin-top": "24px" },
          model: {
            value: _setup.isPublish,
            callback: function ($$v) {
              _setup.isPublish = $$v
            },
            expression: "isPublish",
          },
        },
        [
          _c(
            "el-radio",
            {
              staticStyle: { display: "block", "margin-bottom": "12px" },
              attrs: { label: 1 },
            },
            [_vm._v("发布商品")]
          ),
          _c(
            "el-radio",
            { staticStyle: { display: "block" }, attrs: { label: 0 } },
            [_vm._v("不发布商品")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            "margin-top": "24px",
            display: "flex",
            "justify-content": "end",
            "align-items": "center",
          },
        },
        [
          _c(
            "el-button",
            { attrs: { size: "mini" }, on: { click: _setup.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { loading: _setup.isSync, size: "mini", type: "primary" },
              on: { click: _setup.requestOfSync },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }